


























import { Component, Vue, Prop, PropSync } from "vue-property-decorator";
import _ from "lodash";

@Component
export default class RightDrawer extends Vue {
  @PropSync('open', { default: false }) internalOpen?: boolean;
  @PropSync('saving', { default: false }) internalSaving?: boolean;
  @Prop() initial?: any;
  @Prop() watched?: any;
  @Prop() width?: any;
  @Prop() isWatchedValid?: boolean;
  @Prop() message?: string;

  get isWatchMode(): boolean {
    return !_.isUndefined(this.initial) && !_.isUndefined(this.watched);
  }

  get dirty() {
    return this.isWatchMode && !_.isEqual(this.initial, this.watched);
  }

  clickOverlay() {
    //disable user from closing drawer if the form is saving
    if (!this.internalSaving) {
      if (this.isWatchMode) {
        if (this.dirty) {
          this.$store.dispatch("showNotification", {
            color: "warning",
            message: this.message ?? this.$t(
              "Changes pending. Are you sure you want to close the form?"
            ),
            actions: [
              {
                text: this.$t("Yes"),
                fun: () => {
                  this.internalOpen = false;
                  return true;
                },
              },
              {
                text: this.$t("No"),
                fun: () => {
                  return true;
                },
              },
            ],
            timeout: 5000,
          });
        } else {
          this.internalOpen = false;
        }
      } else {
        this.internalOpen = false;
      }
    }
  }
}
